/** @format */

const template = `
<div class="module-content-application-structure">
  <div class="mca-border">
    <div class="accordion-panel accordion-panel-noblock-dotted-content">
      <div class="header">
        <a class="collapse disabled" role="button" aria-hidden="true">
          <sis-icon [icon]="'chevron-ring'" [color]="'light'" [icon-class]="'cw-90'"></sis-icon
        ></a>
        <div class="title">
          <span>{{ ctrl.module.name | localizedString}}</span>
          <span class="additional" ng-if="ctrl.module.code">{{ctrl.module.code}}</span>
        </div>
      </div>
      <div class="content">
        <div class="content-row">
          <div class="content-text">
            <div class="row">
              <div class="col-sm-6" ng-repeat="courseUnit in ctrl.selectedCourseUnits track by $index">
                <article
                  ng-init="attainment = ctrl.selectedCourseUnitAttainmentsByGroupId[courseUnit.groupId]"
                  class="courseunit cu-color-1">
                  <div class="courseunit-top-row">
                    <div class="credits-box">
                      <span ng-if="!attainment" class="credit-amount">{{ courseUnit.credits | creditRange }}</span>
                      <span ng-if="attainment" class="credit-amount">{{ attainment.credits | decimalNumber }}</span>
                      <span class="credit-abbreviation" translate="CREDITS">op</span> </div
                    ><!--
                                        --><div ng-if="attainment" class="grade-box">
                      <sis-icon icon="achievement"></sis-icon>
                      <span class="grade-text" ng-if="ctrl.gradeScalesById"
                        >{{ctrl.gradeScalesById[attainment.gradeScaleId].grades[attainment.gradeId].abbreviation|localizedString}}</span
                      >
                      <span class="grade-text" ng-if="attainment.grade">{{attainment.grade.abbreviation|localizedString}}</span>
                    </div>
                    <div class="title-box">
                      <span class="courseunit-code"><sis-icon icon="brochure"></sis-icon>{{ courseUnit.code }}</span>
                      <span class="courseunit-title">{{ courseUnit.name | localizedString }}</span>
                    </div>
                  </div>
                </article>
              </div>
              <div class="col-sm-6" ng-repeat="customCourseUnitAttainment in ctrl.selectedCustomCourseUnitAttainments">
                <article class="courseunit cu-color-1">
                  <div class="courseunit-top-row">
                    <div class="credits-box">
                      <span class="credit-amount">{{ customCourseUnitAttainment.credits | decimalNumber }}</span>
                      <span class="credit-abbreviation" translate="CREDITS">op</span> </div
                    ><!--
                                        --><div class="grade-box">
                      <sis-icon icon="achievement"></sis-icon>
                      <span class="grade-text" ng-if="ctrl.gradeScalesById"
                        >{{ctrl.gradeScalesById[customCourseUnitAttainment.gradeScaleId].grades[customCourseUnitAttainment.gradeId].abbreviation|localizedString}}</span
                      >
                      <span class="grade-text" ng-if="customCourseUnitAttainment.grade"
                        >{{customCourseUnitAttainment.grade.abbreviation|localizedString}}</span
                      >
                    </div>
                    <div class="title-box">
                      <span class="courseunit-code"><sis-icon icon="brochure"></sis-icon>{{ customCourseUnitAttainment.code }}</span>
                      <span class="courseunit-title">{{ customCourseUnitAttainment.name | localizedString }}</span>
                    </div>
                  </div>
                  <div class="cu-notification-bar">
                    <sis-tooltip
                      ng-if="ctrl.getRelatedCustomStudyDraftForCustomCourseUnitAttainment(customCourseUnitAttainment)"
                      tooltip-text="{{'SIS_COMPONENTS.MODULE_CONTENT_APPLICATION_STRUCTURE.REPLACES_CUSTOM_STUDY_DRAFT' | translate}} {{ctrl.getRelatedCustomStudyDraftForCustomCourseUnitAttainment(customCourseUnitAttainment).name}}">
                      <div class="cu-notification sis-tooltip-trigger-content">
                        <span class="cu-notification-header"><sis-icon icon="info"></sis-icon></span
                        ><!--
                                           --><span class="cu-notification-content">
                          <span translate="SIS_COMPONENTS.MODULE_CONTENT_APPLICATION_STRUCTURE.REPLACES_CUSTOM_STUDY_DRAFT"></span>: {{
                          ctrl.getRelatedCustomStudyDraftForCustomCourseUnitAttainment(customCourseUnitAttainment).name }}
                        </span>
                      </div>
                    </sis-tooltip>
                  </div>
                </article>
              </div>
              <div class="col-sm-6" ng-repeat="customStudyDraft in ctrl.effectiveCustomStudyDrafts">
                <article class="courseunit cu-color-custom-study-draft">
                  <div class="courseunit-top-row">
                    <div class="credits-box">
                      <span class="credit-amount">{{ customStudyDraft.credits | decimalNumber }}</span>
                      <span class="credit-abbreviation" translate="CREDITS">op</span>
                    </div>
                    <div class="title-box">
                      <span class="courseunit-code"><sis-icon icon="brochure"></sis-icon>Opintoluonnos</span>
                      <span class="courseunit-title">{{ customStudyDraft.name }}</span>
                    </div>
                  </div>
                </article>
              </div>
              <div class="col-sm-6" ng-repeat="selectedModule in ctrl.selectedModules">
                <div ng-init="attainment = ctrl.selectedModuleAttainmentsByGroupId[selectedModule.groupId]" class="studymodule cu-color-0">
                  <div class="studymodule-top-row">
                    <div class="title-box">
                      <span class="studymodule-title">{{ selectedModule.name | localizedString }}</span>
                      <span class="studymodule-code"> <sis-icon icon="brochure"></sis-icon>{{ selectedModule.code }} </span> </div
                    ><!--
                                     --><div class="extra-items-holder">
                      <div ng-if="attainment" class="grade-box">
                        <sis-icon icon="achievement"></sis-icon>
                        <span class="grade-text" ng-if="ctrl.gradeScalesById && !attainment.grade"
                          >{{ctrl.gradeScalesById[attainment.gradeScaleId].grades[attainment.gradeId].abbreviation|localizedString}}</span
                        >
                        <span class="grade-text" ng-if="attainment.grade">{{attainment.grade.abbreviation|localizedString}}</span> </div
                      ><!--
                                            --><div class="credits-box" ng-if="selectedModule.type !== 'GroupingModule'">
                        <span ng-if="!attainment" class="credit-amount">{{ selectedModule.targetCredits | creditRange }}</span>
                        <span ng-if="attainment" class="credit-amount">{{ attainment.credits | decimalNumber }}</span>
                        <span class="credit-abbreviation" translate="CREDITS">op</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6" ng-repeat="customModuleAttainment in ctrl.selectedCustomModuleAttainments">
                <div class="studymodule cu-color-0">
                  <div class="studymodule-top-row">
                    <div class="title-box">
                      <span class="studymodule-title">{{ customModuleAttainment.name | localizedString }}</span>
                      <span class="studymodule-code"> <sis-icon icon="brochure"></sis-icon>{{ customModuleAttainment.code }} </span> </div
                    ><!--
                                     --><div class="extra-items-holder">
                      <div class="grade-box">
                        <sis-icon icon="achievement"></sis-icon>
                        <span class="grade-text" ng-if="ctrl.gradeScalesById && !customModuleAttainment.grade"
                          >{{ctrl.gradeScalesById[customModuleAttainment.gradeScaleId].grades[customModuleAttainment.gradeId].abbreviation|localizedString}}</span
                        >
                        <span class="grade-text" ng-if="customModuleAttainment.grade"
                          >{{customModuleAttainment.grade.abbreviation|localizedString}}</span
                        > </div
                      ><!--
                                            --><div class="credits-box">
                        <span class="credit-amount">{{ customModuleAttainment.credits | decimalNumber}}</span>
                        <span class="credit-abbreviation" translate="CREDITS">op</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12" ng-repeat="selectedGroupingModule in ctrl.selectedGroupingModules">
                <div class="grouping-module">
                  <div class="accordion-panel accordion-panel-noblock">
                    <div class="header">
                      <a href class="collapse disabled collapsed" role="button" aria-hidden="true">
                        <sis-icon [icon]="'chevron-ring'" [color]="'light'" [icon-class]="'cw-90'"></sis-icon
                      ></a>
                      <div class="title">{{ selectedGroupingModule.name | localizedString}}</div>
                      <div class="content collapsed"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default template;
